import { render, staticRenderFns } from "./supplierRegister.vue?vue&type=template&id=283dbab6&scoped=true&"
import script from "./supplierRegister.vue?vue&type=script&lang=js&"
export * from "./supplierRegister.vue?vue&type=script&lang=js&"
import style0 from "./supplierRegister.vue?vue&type=style&index=0&id=283dbab6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "283dbab6",
  null
  
)

export default component.exports